import { useEffect, useState } from 'react';

import { Box, Transition } from '@mantine/core';

import { ToolCallAction, UiNode } from '@repo/contracts';

import { UiTreeRenderer } from '@components/chatbot/UiTreeRenderer';

interface ToolRendererProps {
    toolCall: ToolCallAction;
    onAction?: (key: string, label: string) => void;
}

export function ToolRenderer({ toolCall, onAction }: ToolRendererProps) {
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        setMounted(true);
    }, []);

    if (toolCall.name === 'presentLayout') {
        const root = toolCall.args?.root as UiNode | undefined;
        if (!root) return null;

        return (
            <Transition mounted={mounted} transition="slide-up" duration={400} timingFunction="ease">
                {(styles) => (
                    <Box style={styles} w="100%">
                        <UiTreeRenderer node={root} onAction={onAction} />
                    </Box>
                )}
            </Transition>
        );
    }

    return null;
}
